t = require('views/internal/teacup-with-helpers')('member_cards_board')

module.exports = t.renderable ({ url, name, org, permissionLevel, starred, lists }) ->
  t.div '.member-cards-board.js-board', ->
    t.div '.board-header', ->
      t.a '.board-header-btn.no-edit.board-header-btn-name', { href: url }, ->
        t.span '.board-header-btn-text', ->
          t.text name
      if starred
        t.a '.board-header-btn.no-edit', ->
          t.span '.icon-sm.icon-star.board-header-btn-icon'
      if org?
        t.a '.board-header-btn.board-header-btn-org-name.board-header-btn-without-icon', { href: org.url }, ->
          t.span '.board-header-btn-text', ->
            t.text org.name
      t.span '.board-header-btn.perms-btn.no-edit.js-permission-level', ->
        t.span '.icon-sm', { class: t.classify({
          'icon-organization-visible': permissionLevel == 'org'
          'icon-public': permissionLevel == 'public'
          'icon-private': permissionLevel == 'private'
        }) }

    t.div '.member-cards-board-lists.u-fancy-scrollbar', ->
      for list in lists
        t.div '.list-wrapper', ->
          t.div '.list', ->
            t.div '.list-header.u-clearfix', ->
              t.div '.list-header-name.mod-list-name', ->
                t.text list.name
            t.div '.js-list.list-cards.u-fancy-scrollbar', { 'data-idList': list.id }



// WEBPACK FOOTER //
// ./app/scripts/views/templates/member_cards_board.coffee